import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { api } from '@/utils/api';
import { SignInResponseDto } from '@/model/generated';
import { Ref, unref } from 'vue';

export const useSendOtpCode = (phoneNumber: Ref<string> | string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return api.post<SignInResponseDto>('/sign-in', {
        username: unref(phoneNumber),
      });
    },
    onSuccess: ({ data }) => {
      queryClient.setQueryData(['session'], data);
    },
  });
};
